import API from 'utils/api';
import { ESTATUS_AUTORIZADO } from 'utils/constants';
import { formatReceived } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = '/nominas/solicitud-de-contratacion';

/**
 * GET directorio de area
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getSolicitudesDeContratacionFiltro = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

export const getSolicitudesDeContratacion = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET solicitud de area
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getSolicitudDeContratacion = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Crear solicitud de area
 * @param {object} data
 * @returns {Promise<object>}
 */
export const postSolicitudDeContratacion = async (data) => {
  try {
    const response = await API.post(baseURI, data);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * PATCH Editar solicitud de area
 * @param {object} data
 * @param {number} id
 * @returns {Promise<object>}
 */
export const patchSolicitudDeContratacion = async (id, data) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, data);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * DELETE solicitud de area
 * @param {number} id
 * @returns {Promise<object>}
 */
export const deleteSolicitudDeContratacion = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * GET catalogos/comprobantedeestudio/
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getComprobantesDeEstudio = async (params) => {
  try {
    const response = await API.get('/catalogos/comprobante-de-estudio', { params });
    return { ...response.data, results: formatReceived(response.data.results) };
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * AUTORIZAR SolicitudDeContratacion
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarSolicitudDeContratacion = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * GET SOLICITUD DE CONTRATACION VISTA OPTIMIZED
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getSolicitudDeContratacionvistaOptimized = async (params) => {
  try {
    const response = await API.get('/nominas/solicitud-de-contratacion-vista-optimized', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Descargar plantilla Excel para carga masiva de Vacantes (generada en el backend)
 */
export const descargarPlantillaVacantes = async () => {
  const response = await API.get(
    '/nominas/solicitud-de-contratacion-obtener-plantilla-excel/',
    { responseType: 'arraybuffer' },
  );
  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', 'Layout_Vacantes.xlsx');
  document.body.appendChild(link);
  link.click();
  link.parentNode.removeChild(link);
  window.URL.revokeObjectURL(url);
};
